import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';
import { OversightColumn } from './OversightColumn';

const withoutOversight = [
    'You assume the work is getting done',
    'Problems surface months too late',
    'You become the bottleneck for accountability',
    'Drift goes unnoticed until performance drops',
    'You manage by gut feeling',
];

const withOversight = [
    'You know exactly how time is being spent',
    'Issues are flagged within the first billing cycle',
    'Accountability is built into the system',
    'Drift is caught and corrected early',
    'You manage by data',
];

export function ComparisonTable() {
    return (
        <section className="bg-[#F8F9FA] py-24 md:py-32" data-testid="comparison-section">
            <div className="max-w-5xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="text-center mb-14">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight">
                        This Is What Separates a Managed VA from an Unsupervised One.
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <OversightColumn title="Without Oversight" items={withoutOversight} positive={false} testId="without-oversight" />
                    <OversightColumn title="With White Glove Oversight" items={withOversight} positive testId="with-oversight" />
                </div>
            </div>
        </section>
    );
}
